import { render, staticRenderFns } from "./moduleTwelve.vue?vue&type=template&id=9b0ae440"
import script from "./moduleTwelve.vue?vue&type=script&lang=js"
export * from "./moduleTwelve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports